import * as Filters from 'ml-signal-processing';
export const id = 'signalProcessing';
export const name = 'Signal processing';
export const DOMAIN_UPDATE_RULES = {
    updateXDomain: true,
    updateYDomain: true,
};
export function apply(spectrum, options) {
    if (!isApplicable(spectrum)) {
        throw new Error('Signal Processing is not applicable on this data');
    }
    spectrum.data = filterXY(spectrum, options);
}
export function isApplicable(spectrum) {
    if (spectrum.info.isFt)
        return true;
    return false;
}
export function reduce(previousValue, newValue) {
    return {
        once: true,
        reduce: newValue,
    };
}
export function filterXY(spectrum, options) {
    let x = spectrum.data.x.slice(0);
    const cloneX = spectrum.data.x.slice(0);
    let re = spectrum.data.re.slice(0);
    let im = spectrum.data.im?.slice(0);
    const filters = options.filters.slice();
    const { range: { from, to }, numberOfPoints, exclusionsZones: exclusions, } = options;
    filters.push({
        name: 'equallySpaced',
        options: { from, to, numberOfPoints, exclusions },
        properties: {},
    });
    for (const filter of filters) {
        // eslint-disable-next-line import/namespace
        const filterFunction = Filters[filter.name];
        if (!filterFunction) {
            throw new Error(`Unknown filter: ${filter.name}`);
        }
        const filterOptions = filter?.options || {};
        // @ts-expect-error some method have options and some other ones don't have any options
        const realResult = filterFunction({ x, y: re }, filterOptions);
        x = realResult.data.x;
        re = realResult.data.y;
        if (im) {
            const imaginaryResult = filterFunction({ x: cloneX, y: im }, 
            // @ts-expect-error some method have options and some other ones don't have any options
            filterOptions);
            im = imaginaryResult.data.y;
        }
    }
    return { x, re, im };
}
//# sourceMappingURL=signalProcessing.js.map